import { BRAND_WAREHOUSE_CREATE, BRAND_WAREHOUSE_DELETE, BRAND_WAREHOUSE_UPDATE } from "constants/action-types";

export const deleteWarehouse = (warehouse) => ({
    payload: warehouse,
    type: BRAND_WAREHOUSE_DELETE,
});

export const updateWarehouse = (warehouse) => ({
    payload: warehouse,
    type: BRAND_WAREHOUSE_UPDATE,
});

export const createWarehouse = (warehouse) => ({
    payload: warehouse,
    type: BRAND_WAREHOUSE_CREATE,
});
